import styled, { css } from 'styled-components';

export const ContentCss = css`
  -webkit-user-select: text; /* Safari */
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text; /* Internet explorer */
  user-select: text;
  padding-right: 16px;
  color: ${(props) => props.theme.colors.gray900};
  font-size: 14px;
  line-height: 1.7;
  word-break: keep-all;
  font-family:
    'Instrument Sans',
    'Pretendard',
    -apple-system,
    BlinkMacSystemFont,
    Roboto,
    helvetica,
    Apple SD Gothic Neo,
    sans-serif;

  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    font-weight: 700;
  }
  p {
    margin-bottom: 8px;
  }
  ul,
  ol {
    padding-left: 24px;
  }
  li {
    margin-bottom: 8px;
  }
  a {
    color: ${(props) => props.theme.colors.primary100};
    text-decoration: underline;
  }
  code {
    font-family: monospace;
    font-weight: 400;
    font-size: 12px;
    padding: 0 4px;
    background-color: ${(props) => props.theme.colors.gray200};
    border: 1px solid ${(props) => props.theme.colors.gray400};
    border-radius: 4px;
    color: ${(props) => props.theme.colors.red600};
  }
  blockquote {
    border-left: 4px solid ${(props) => props.theme.colors.gray400};
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
    margin-left: 0px;
  }
  pre {
    display: block;
    width: 100%;
    padding: 4px 8px;
    background-color: ${(props) => props.theme.colors.gray200};
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors.gray400};
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: ${(props) => props.theme.colors.gray700};
    font-family: monospace;
    code {
      white-space: pre-wrap;
      width: 100%;
      word-break: break-all;
      padding: 0;
      background-color: transparent;
      border: none;
      border-radius: 0;
      color: ${(props) => props.theme.colors.gray700};
    }
  }
  img {
    max-width: 100%;
    cursor: pointer;
  }
  mark {
    background-color: ${(props) => props.theme.colors.mark};
    color: ${(props) => props.theme.colors.gray700};
  }

  hr {
    margin: 16px 0;
  }
`;

export const ContentStyle = styled.div`
  ${ContentCss};

  .intercom-container {
    img {
      height: 400px;
      width: auto;
    }
  }

  .content-body-tag__default {
    position: relative;
    padding: 1px 0;
    transition: all 0.2s;
    border-bottom: 1px solid transparent;
    border-color: ${(props) => props.theme.colors.primary100};
    &:hover {
      border-color: transparent;
    }
    &.block-focused {
      border-color: transparent;
    }
    &.sentiment_POSITIVE {
      border-color: ${(props) => props.theme.colors.green500};
      &.block-focused {
        background-color: ${({ theme }) => theme.colors.green(0.3)};
      }
    }
    &.sentiment_NEGATIVE {
      border-color: ${(props) => props.theme.colors.red600};
      &.block-focused {
        background-color: ${({ theme }) => theme.colors.red(0.3)};
      }
    }
    &.sentiment_NEUTRAL {
      border-color: ${(props) => props.theme.colors.gray600};
      &.block-focused {
        background-color: ${({ theme }) => theme.colors.ND08};
      }
    }
  }
`;
